export const mail = {
'站内信': 'メールボックス',
'返回': '戻る',
'有未读信息': '未読のメッセージが{amount}件あります',
'全部标记为已读': 'すべて既読にする',
'隐藏已读消息': '既読のメッセージを非表示',
'展开': 'さらに表示'
};


// WEBPACK FOOTER //
// ./src/i18n/lang/mail/ja_JP.js